export default {
  tabs: {
    schedule: "Agenda",
    history: "Histórico",
    logs: "Logs"
  },
  engineQueue: {
    loading: "Carregando fila do Engine...",
    loadError: "Não foi possível carregar a fila do Engine.",
    autoRefresh: "Atualização automática a cada 5s",
    jobsTitle: "Jobs de execução de workflow",
    searchPlaceholder: "Buscar por agente, trigger, estado ou execução...",
    empty: "Nenhum job na fila.",
    retry: "Reprocessar",
    retried: "Job reenfileirado.",
    retryError: "Não foi possível reprocessar o job.",
    remove: "Remover",
    removed: "Job removido.",
    removeError: "Não foi possível remover o job.",
    removeConfirm: "Remover este job da fila? Esta ação não pode ser desfeita.",
    metrics: {
      waiting: "Aguardando",
      active: "Ativos",
      delayed: "Adiados",
      failed: "Falhas",
      completed: "Concluídos"
    },
    columns: {
      enqueuedAt: "Criado",
      agent: "Agente",
      trigger: "Trigger",
      state: "Estado",
      attempts: "Tentativas",
      actions: "Ações"
    }
  },
  schedule: {
    activeCalls: "Chamadas Ativas",
    upcomingMeetings: "Próximas Reuniões",
    withError: "Com Erro",
    activeCallsTitle: "Chamadas Ativas",
    upcomingMeetingsTitle: "Próximas Reuniões",
    calendarMeetingsTitle: "Reuniões da Agenda",
    mailboxHint: "Calendário lido pelo Prodgy",
    statuses: {
      ready: "Pronta",
      rejected: "Rejeitada"
    },
    filters: {
      status: "Situação",
      workspace: "Workspace",
      allStatuses: "Todas as situações",
      allWorkspaces: "Todos os workspaces"
    },

    searchPlaceholder: "Buscar por reunião, nome, data...",
    noUpcomingMeetings: "Nenhuma reunião nos próximos dias",
    rowsPerPage: "Linhas por página",
    pagination: "{{current}} de {{total}}",
    series: "Série",
    seriesTooltip_one: "{{count}} ocorrência desta série na janela lida",
    seriesTooltip_other: "{{count}} ocorrências desta série na janela lida",
    untitledMeeting: "Reunião sem título",
    periods: {
      today: "Hoje",
      tomorrow: "Amanhã",
      all: "Toda a janela"
    },
    a11y: {
      openMenu: "Abrir menu da reunião",
      previousPage: "Página anterior",
      nextPage: "Próxima página",
      rejectionReason: "Por que esta reunião foi rejeitada",
    },
    syncNow: "Sincronizar agora",
    syncRequested: "Leitura da agenda solicitada",
    actionError: "Falha na ação — tente novamente",
    reasons: {
      organizer_not_registered: "Organizador não cadastrado",
      no_active_webhook: "Sem agente ativo",
      workspace_ambiguous: "Workspace ambíguo",
      no_teams_link: "Sem link do Teams",
      blocked: "Bloqueada manualmente",
      not_recorded: "Falha ao registrar",
      unknown: "Motivo desconhecido"
    },
    reasonHelp: {
      organizer_not_registered: "Quem organizou a reunião não tem cadastro no Prodgy.",
      no_active_webhook: "O organizador não tem um agente ativo para receber a transcrição.",
      workspace_ambiguous: "O organizador tem mais de um workspace e nenhum foi indicado no título.",
      no_teams_link: "A reunião não tem link do Teams para o Prodgy entrar.",
      blocked: "Um administrador bloqueou esta reunião no painel.",
      not_recorded: "O Prodgy não conseguiu registrar esta reunião e não entrou para não repetir a entrada depois.",
      unknown: "Não foi possível determinar o motivo."
    },
    columns: {
      created: "Criado",
      from: "De",
      meeting: "Reunião",
      workspace: "Workspace",
      scheduled: "Agendado",
      startTime: "Início",
      endTime: "Fim",
      reason: "Motivo",
      status: "Situação",
      time: "Horário",
      actions: "Ações",
      callId: "ID da Chamada"
    },
    actions: {
      details: "Detalhes",
      blockMeeting: "Não atender esta reunião",
      blockSeries: "Não atender a série",
      forceLeave: "Forçar Saída"
    },
    confirmBlockMeetingTitle: "Não atender esta reunião",
    confirmBlockMeetingDescription: "O Prodgy deixará de entrar nesta reunião, mesmo que ela continue na agenda.",
    confirmBlockSeriesTitle: "Não atender a série",
    confirmBlockSeriesDescription: "O Prodgy deixará de entrar em todas as reuniões desta série, mesmo que continuem na agenda.",
    confirmForceLeaveTitle: "Forçar Saída da Chamada",
    confirmForceLeaveDescription: "Tem certeza que deseja forçar a saída desta chamada ativa? Esta ação não pode ser desfeita.",
    confirmCancelButton: "Cancelar",
    confirmButton: "Confirmar"
  },
  details: {
    meetingTitle: "Detalhes da Reunião",
    notAttendedTitle: "Por que não será atendida",
    callTitle: "Detalhes da Chamada Ativa",
    subject: "Assunto",
    from: "De",
    workspace: "Workspace de destino",
    scheduled: "Agendado",
    scheduledTime: "Horário Agendado",
    startTime: "Horário de Início",
    meetingUrl: "Link da Reunião",
    recurring: "Recorrente",
    transcriptionLanguage: "Idioma da transcrição",
    maxWait: "Espera máxima",
    recurrenceDetail: "Padrão da recorrência",
    recurrenceEndsAt: "Recorrência termina em",
    recurrencePatterns: {
      daily: "Diária",
      weekly: "Semanal",
      monthly: "Mensal",
      yearly: "Anual"
    },
    minutes_one: "{{count}} minuto",
    minutes_other: "{{count}} minutos",
    yes: "Sim",
    no: "Não",
    callId: "ID da Chamada"
  },
  history: {
    title: "Histórico de Reuniões",
    today: "Hoje",
    last7Days: "7 dias",
    last30Days: "30 dias",
    last90Days: "90 dias",
    loading: "Carregando histórico de reuniões...",
    connectionError: "Erro ao conectar com o serviço. Tente novamente.",
    noMeetingEvents: "Nenhum evento de reunião encontrado neste período. Realize uma reunião com o Assistant para ver o histórico aqui.",
    events: "eventos",
    segments: "segmentos",
    participants: "participantes",
    duration: "Duração",
    meeting: "Reunião",
    downloadTranscript: "Baixar transcrição",
    downloadTranscriptError: "Não foi possível gerar o link de download.",
    eventTypes: {
      scheduled: "Agendado",
      joined: "Entrou",
      transcription: "Transcrição Entregue",
      left: "Saiu",
      error: "Erro"
    },
    status: {
      delivered: "Entregue",
      in_progress: "Em Andamento",
      error: "Erro",
      completed: "Concluído",
      scheduled: "Agendado"
    }
  },
  logs: {
    title: "Logs",
    streaming: "Streaming",
    allLevels: "Todos os Níveis",
    info: "Info",
    warn: "Aviso",
    error: "Erro",
    start: "Iniciar",
    stop: "Parar",
    clear: "Limpar",
    terminalTitle: "Logs do Assistente",
    lineCount: "{{count}} linhas",
    noLogEntries: "Nenhuma entrada de log para exibir",
    searchPlaceholder: "Buscar nos logs...",
    level: "Nível",
    lines: "linhas",
    connectionError: "Erro ao conectar com o serviço de logs. Tente novamente.",
    description: "Visualize logs do sistema em tempo real"
  },
  config: {
    title: "Configurações",
    loading: "Carregando configurações...",
    general: "Geral",
    baseUrl: "URL Base",
    assistantBaseUrl: "URL Base do Assistente",
    apiConnection: "Conexão API",
    engine: "Engine",
    apiBaseUrl: "URL Base",
    apiKey: "Chave da API",
    agentName: "Nome do Agente",
    calendarService: "Serviço de Calendário",
    mailboxEnabled: "Habilitado",
    mailbox: "Conta do Calendário (caixa de e-mail)",
    pollInterval: "Intervalo de Sincronização do Calendário (minutos)",
    horizonDays: "Janela de leitura (dias)",
    maxWaitMinutes: "Tempo Máximo de Espera (minutos)",
    graphTenantId: "Graph Tenant ID",
    graphClientId: "Graph Client ID",
    graphClientSecret: "Graph Client Secret",
    logs: "Logs",
    logsApiKey: "Chave da API",
    logsDirectory: "Diretório de Logs",
    microsoftTeams: "Microsoft Teams",
    azureAd: "Azure AD",
    azureAdTenantId: "Tenant ID",
    azureAdClientId: "Client ID",
    azureAdClientSecret: "Client Secret",
    azureBot: "Azure Bot",
    botUserId: "Bot User ID",
    botName: "Nome do Bot",
    botBaseUrl: "URL Base",
    certThumbprint: "Thumbprint do Certificado",
    save: "Salvar",
    saving: "Salvando...",
    restartWarning: "Algumas alterações podem exigir uma reinicialização"
  }
} as const;